import React, { useState, useEffect } from 'react'
import axios from 'axios'
import ReactGA from 'react-ga'

import questions from '../../data/questions'
import QuestionSection from '../../components/QuestionSection/QuestionSection'
import Question from '../../components/Question/Question'
import Result from '../../components/Result/Result'
import getFormattedData from './getFormattedData'
import { testUrl } from '../../data/urls'
import getLink from '../../utils/getLink'

// TODO add contentful

const Survey = ({ navigate, routePath, voucher, demo }) => {
  // section or group os questions
  const [questionGroupNumber, setQuestionGroupNumber] = useState(0)
  // const [questionGroupNumber, setQuestionGroupNumber] = useState(1)
  const [answers, setAnswers] = useState({
    demographic: {},
    health: {}
  })
  // initial -> number of question -> result
  const [step, setStep] = useState('initial')
  // const [step, setStep] = useState(0)
  const [loading, setLoading] = useState(false)

  const isFemale = answers.demographic.sex === 'female'
  const totalQuestionsLength =
    questions[0].questions.length + questions[1].questions.length

  const getTotalStep = () => {
    if (questionGroupNumber === 0) {
      return step
    } else {
      return questions[0].questions.length + step
    }
  }

  useEffect(() => {
    // warming up the machine
    axios.get(`${testUrl}/start`)
    ReactGA.pageview(window.location.pathname + window.location.search)
  }, [])

  const handleSectionProceed = () => {
    // start/continue button click
    if (step === 'initial') {
      setStep(0)
    } else {
      navigate(getLink(routePath, '/recommendations'))
    }
  }

  const checkStep = () => {
    if (isFemale) {
      return questions[questionGroupNumber].questions.length - 1
    } else {
      return (
        questions[questionGroupNumber].questions.filter(
          (question) => question.condition !== 'female'
        ).length - 1
      )
    }
  }

  const handleQuestionAnswered = (answer) => {
    // get current group id
    const { groupId } = questions[questionGroupNumber]
    // copy new answers and use new values on current group id
    const newAnswers = { ...answers }

    // clean all female answers we have so far
    // in case user returned and chose different sex
    if (answer.sex === 'male') {
      delete newAnswers.health['breast-cancer-screening']
      delete newAnswers.health['breast-cancer']
    }

    newAnswers[groupId] = { ...answers[groupId], ...answer }
    // set answers
    setAnswers(newAnswers)

    // if it's not latest question - increase step number
    if (step < checkStep()) {
      setStep(step + 1)
    } else {
      // if it is
      if (questionGroupNumber === 0) {
        // go to section 2 in case of section 1
        setQuestionGroupNumber(1)
        setStep('initial')
      } else if (questionGroupNumber === 1) {
        // go to result in case of section 2
        setStep('result')
      }
    }

    window.scrollTo(0, 0)
  }

  const handleBackClick = () => {
    // check if male and going back from results
    if (typeof step === 'number') {
      if (step > 0) {
        setStep(step - 1)
      } else {
        setStep('initial')
      }
    } else {
      // go to previous section and it's last question
      if (step === 'initial') {
        setStep(questions[questionGroupNumber - 1].questions.length - 1)
        setQuestionGroupNumber(questionGroupNumber - 1)
      } else if (step === 'result') {
        setStep(checkStep)
      }
    }

    window.scrollTo(0, 0)
  }

  const getBranch = () => {
    if (isFemale) {
      // return all questions
      return questions[questionGroupNumber]
    } else {
      // return only those questions that does not have female condition
      const filteredQuestions = questions[questionGroupNumber].questions.filter(
        (question) => question.condition !== 'female'
      )

      const newData = {
        ...questions[questionGroupNumber],
        questions: [...filteredQuestions]
      }

      return newData
    }
  }

  // back button exists everywhere except
  // first question section and first question
  const shouldBackButtonExist = !(
    questionGroupNumber === 0 &&
    (step === 0 || step === 'initial')
  )

  const handleDataSubmit = async () => {
    try {
      setLoading(true)
      const response = await axios.post(
        `${testUrl}/surveys`,
        getFormattedData(answers, isFemale, voucher)
      )
      setLoading(false)

      navigate(getLink(routePath, '/recommendations'), {
        state: { responseData: response.data }
      })
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <>
      {/* welcome or section screen with start/continue */}
      {step === 'initial' && (
        <QuestionSection
          onSectionProceed={handleSectionProceed}
          data={questions[questionGroupNumber]}
          onBackClick={handleBackClick}
          shouldBackButtonExist={shouldBackButtonExist}
        />
      )}
      {typeof step === 'number' && (
        <Question
          onBackClick={handleBackClick}
          data={getBranch()}
          onQuestionAnswered={handleQuestionAnswered}
          step={step}
          questionGroupNumber={questionGroupNumber}
          shouldBackButtonExist={shouldBackButtonExist}
          totalQuestionsLength={
            isFemale ? totalQuestionsLength : totalQuestionsLength - 2
          }
          totalStep={getTotalStep()}
          demo={demo}
        />
      )}
      {step === 'result' && (
        <Result
          loading={loading}
          onSectionProceed={handleDataSubmit}
          onBackClick={handleBackClick}
          shouldBackButtonExist
        />
      )}
    </>
  )
}

export default Survey
